module.exports = __webpack_public_path__ + "static/hallway5-5e3833f29e93ee4fe18c305095eeb9f0.jpg";